import React from 'react';
import './NoGroupProfileView.scss';

const NoGroupProfileView = () => {

	return (
		<div className="no-group-container">
			<h3 className="header-text">Profiles is not currently available</h3>
            <p className="no-profile-text">To use the profiles feature, you must first be part of a network.</p>
            <p className="no-profile-sub-text">Create a network or view your pending network invitations here:</p>
            <a href="/dashboard/myenterprise" className="usa-button no-profile-btn">My Network</a>
		</div>
	);
};

export default NoGroupProfileView ;
